<mat-chip class="eiq-badge" [ngClass]="[background(), shape(), height(), useDark() ? 'dark' : '']" [color]="color()" selected [disableRipple]="true">
  @if (indicator()) {
    <span class="eiq-badge__indicator"></span>
  }
  @if (icon()) {
    <fa-icon [icon]="icon()"></fa-icon>
  }
  <span class="eiq-badge__text" [innerHTML]="text()"></span>
</mat-chip>
